import {
  getAdapter,
  setNetworkAdapter,
  fetchAdapter,
  type NetworkAdapter,
  type Req,
} from './adapter';
import { getApiOrigin } from './api-origin';

export { getApiOrigin, setNetworkAdapter, type NetworkAdapter, fetchAdapter };

export async function send<T>(req: Req): Promise<{ status: number; data: T }> {
  const origin = getApiOrigin();
  return await getAdapter()(req, { origin });
}
